import { useMutation } from '@apollo/client';
import { createWishList } from '../../graphql/mutations/wishlistMutations';

export const useCreateWishlist = () => {
  const [createWishlistMutation, { loading, error }] = useMutation(createWishList, {
    refetchQueries: ['WishListsByUserID'],
    awaitRefetchQueries: true
  });

  const sanitizeInput = (input = {}) => {
    const cleaned = { ...input };
    Object.keys(cleaned).forEach((key) => {
      if (cleaned[key] === undefined) {
        delete cleaned[key];
      }
    });
    return cleaned;
  };

  const handleWishlistCreation = async (wishlistData) => {
    try {
      if (!wishlistData?.name || !wishlistData?.userID) {
        throw new Error('Wishlist name and userID are required');
      }

      const input = sanitizeInput({
        name: wishlistData.name,
        userID: wishlistData.userID
      });

      const variables = sanitizeInput({
        input,
        condition: wishlistData?.condition
      });

      const { data: wishlistResponse } = await createWishlistMutation({
        variables
      });

      return wishlistResponse?.createWishList;
    } catch (error) {
      console.error('Error creating wishlist:', error);
      throw error;
    }
  };

  return {
    handleWishlistCreation,
    loading,
    error
  };
};